// =======================================
// archiveManager.js
// Gestion des archives dans IndexedDB
// =======================================

const DB_NAME = "optiscan_db";
const STORE_NAME = "archives";
const DB_VERSION = 2;

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (e) => {
  const db = e.target.result;

  if (!db.objectStoreNames.contains("archives")) {
    db.createObjectStore("archives", { keyPath: "id" });
  }

  if (!db.objectStoreNames.contains("tests")) {
    db.createObjectStore("tests", { keyPath: "id" });
  }
};

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function generateID() {
  return "id-" + Math.random().toString(36).substring(2) + Date.now();
}

export async function saveArchive(archiveData) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    const data = {
      id: generateID(),
      date: Date.now(),
      ...archiveData,
    };

    const request = store.add(data);

    request.onsuccess = () => resolve(data);
    request.onerror = () => reject(request.error);
  });
}

export async function updateArchive(id, updates) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    const getRequest = store.get(id);

    getRequest.onsuccess = () => {
      const existing = getRequest.result;
      if (!existing) {
        reject(new Error("Archive introuvable"));
        return;
      }

      const merged = {
        ...existing,
        ...updates,
        id: existing.id,
        date: existing.date,
      };

      const putRequest = store.put(merged);
      putRequest.onsuccess = () => resolve(merged);
      putRequest.onerror = () => reject(putRequest.error);
    };

    getRequest.onerror = () => reject(getRequest.error);
  });
}

export async function getArchives() {
  const db = await openDB();

  return new Promise((resolve) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);

    const request = store.getAll();

    request.onsuccess = () => {
      const all = request.result.sort((a, b) => b.date - a.date);
      resolve(all);
    };
  });
}

export async function deleteArchive(id) {
  const db = await openDB();

  return new Promise((resolve) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    store.delete(id);

    tx.oncomplete = () => resolve();
  });
}

export async function cleanOldArchives() {
  const archives = await getArchives();
  const limit = 90 * 24 * 60 * 60 * 1000;
  const now = Date.now();

  for (const item of archives) {
    if (now - item.date > limit) {
      await deleteArchive(item.id);
    }
  }
}
